import React from 'react';
import {classes} from './CheckoutButton.st.css';
import classnames from 'clsx';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {SPECS} from '../../../domain/specs';
import {Button, ButtonPriority} from '@wix/wix-ui-tpa/cssVars';

export enum CheckoutButtonDataHook {
  button = 'CheckoutButtonDataHook.button',
}

export interface CheckoutButtonProps {
  disabled?: boolean;
  priority?: ButtonPriority;
  text: string;
  className?: string;
}

export function CheckoutButton({disabled, priority, text, className}: CheckoutButtonProps) {
  const {handleCheckoutButtonHover, checkoutUrl, handleCheckoutButtonClick} = useControllerProps().navigationStore;
  const {experiments} = useExperiments();
  const shouldIgnoreTextOpacity = experiments.enabled(SPECS.ecomIgnoreCartButtonsTextOpacity);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    return handleCheckoutButtonClick();
  };

  return (
    <Button
      href={disabled ? undefined : checkoutUrl?.url}
      as="a"
      priority={priority}
      aria-label={text}
      className={classnames(
        /* istanbul ignore next */ shouldIgnoreTextOpacity
          ? classes.customizableCheckoutButton
          : classes.customizableCheckoutButtonOld,
        disabled && classes.buttonDisabled,
        className
      )}
      data-hook={CheckoutButtonDataHook.button}
      data-wix-checkout-button={CheckoutButtonDataHook.button}
      onClick={onClick}
      onMouseEnter={() => handleCheckoutButtonHover()}
      disabled={disabled}
      upgrade>
      {text}
    </Button>
  );
}
